import { useMutation, useQuery } from 'react-query';
import queryGetGeolocation from './queries/getGeolocation';
import queryGetConnectionPoints from './queries/getConnectionPoints';
import queryGetEventLogs from './queries/getEventLogs';
import queryTransactions from './queries/getTransactions';
import mutationBlacklistPosTerminal from './mutations/blacklistPosTerminal';
import mutationUnblacklistPosTerminal from './mutations/unblacklistPosTerminal';
import mutationRewarehousePosTerminal from './mutations/rewarehousePosTerminal';
import mutationUpdatePosTerminalLabels from './mutations/updatePosTerminalLabels';
import mutationMultiplePosBlocking from './mutations/multiplePosBlocking';
import mutationMultiplePosActivation from './mutations/multiplePosActivation';

const actionsPosTerminals = {
    // Getters
    getGeolocation: (posTerminalUuid) => useQuery(queryGetGeolocation(posTerminalUuid)),
    getConnectionPoints: (subscriptionId) => useQuery(queryGetConnectionPoints(subscriptionId)),
    getEventLogs: (params, enabled) => useQuery(queryGetEventLogs(params, enabled)),
    getTransactions: (params, enabled) => useQuery(queryTransactions(params, enabled)),

    // Mutations
    // Blacklist
    blacklistPosTerminal: (onSuccess, onError) => useMutation(mutationBlacklistPosTerminal(onSuccess, onError)),
    unblacklistPosTerminal: (onSuccess, onError) => useMutation(mutationUnblacklistPosTerminal(onSuccess, onError)),

    // In stock
    rewarehousePosTerminal: (onSuccess, onError) => useMutation(mutationRewarehousePosTerminal(onSuccess, onError)),

    // Labels
    updatePosTerminalLabels: (onSuccess, onError) => useMutation(mutationUpdatePosTerminalLabels(onSuccess, onError)),

    // Multiple activation
    multiplePosActivation: (onSuccess, onError) => useMutation(mutationMultiplePosActivation(onSuccess, onError)),

    // Multiple blocking
    multiplePosBlocking: (onSuccess, onError) => useMutation(mutationMultiplePosBlocking(onSuccess, onError))
};

export default actionsPosTerminals;